import { ThemeEvents, CartAddEvent, CartErrorEvent, VariantUpdateEvent } from '@theme/events';

class WIquickadd extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.clickAdd();
    }

    clickAdd() {
        let addBtn = this.querySelector("button");
        addBtn?.addEventListener("click", async ()=>{
          addBtn.querySelector(".WI_productCard_info_atc_text").style.display = "none";
          addBtn.querySelector(".WI_loadingSpinner").style.display = "block";
            let varId = addBtn.getAttribute("data-id");
            let formData = {
                'items': [{
                'id': varId,
                'quantity': 1
                }]
            };
            try {
  const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.description || 'Failed to add product to cart');
  }

  const item = data.items[0];

  this.dispatchEvent(
    new CartAddEvent({}, item.id.toString(), {
      source: 'custom-code',
      itemCount: item.quantity,
      productId: item.product_id
    })
  );
   addBtn.querySelector(".WI_productCard_info_atc_text").style.display = "flex";
    addBtn.querySelector(".WI_loadingSpinner").style.display = "none";


} catch (error) {
  console.error('Error:', error);
}
        });
    }
}

customElements.define('wi-quickadd', WIquickadd);